__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "hostedTracking";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "15.2.9", () => (Promise.all([__webpack_require__.e(170), __webpack_require__.e(323), __webpack_require__.e(250), __webpack_require__.e(329)]).then(() => (() => (__webpack_require__(88329))))));
			register("@angular/common", "15.2.9", () => (Promise.all([__webpack_require__.e(323), __webpack_require__.e(12)]).then(() => (() => (__webpack_require__(6012))))));
			register("@angular/core", "15.2.9", () => (Promise.all([__webpack_require__.e(170), __webpack_require__.e(843)]).then(() => (() => (__webpack_require__(41843))))));
			register("@angular/router", "15.2.9", () => (Promise.all([__webpack_require__.e(170), __webpack_require__.e(323), __webpack_require__.e(250), __webpack_require__.e(798), __webpack_require__.e(319)]).then(() => (() => (__webpack_require__(67798))))));
			register("rxjs/operators", "7.8.0", () => (Promise.all([__webpack_require__.e(155), __webpack_require__.e(386)]).then(() => (() => (__webpack_require__(51178))))));
			register("rxjs", "7.8.0", () => (Promise.all([__webpack_require__.e(155), __webpack_require__.e(337)]).then(() => (() => (__webpack_require__(21337))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};